import { useCallback, useEffect, useMemo } from 'react';
import { selectRemainingTime } from 'redux/selectors/selectors';
import { setRemainingTime } from 'redux/slices/app/app.slice';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { LOCAL_STORAGE } from 'shared/constants/local-storage-constants';
import { useGetCurrentDebateQuery } from 'redux/api/debate.api';
import { ERoundStatuses } from 'shared/types/debates.interface';

export const useRemainingTime = () => {
  const dispatch = useAppDispatch();
  const debateId = localStorage.getItem(LOCAL_STORAGE.currentDebateId);
  const { data: currentDebate = null } = useGetCurrentDebateQuery(debateId);
  const currentRound = useMemo(
    () => currentDebate?.rounds.find((round) => round.status === ERoundStatuses.Active) ?? null,
    [currentDebate],
  );
  const lastRound = useMemo(
    () =>
      currentDebate?.rounds.find(
        (round) => round.global_round_number === currentDebate.rounds.length,
      ) ?? null,
    [currentDebate],
  );

  const totalRoundTime = useMemo(
    () => Number(currentRound?.end_time) - Math.floor(new Date().getTime() / 1000),
    [currentRound],
  );
  const remainingTime = useAppSelector(selectRemainingTime);

  const updateRemainingTime = useCallback(
    (totalRemainingTime, roundRemainingTime) =>
      dispatch(
        setRemainingTime({
          totalRemainingTime,
          roundRemainingTime,
        }),
      ),
    [dispatch],
  );

  useEffect(() => {
    if (currentRound) {
      updateRemainingTime(
        Number(lastRound?.end_time) - Math.floor(new Date().getTime() / 1000),
        totalRoundTime,
      );
    }
  }, [updateRemainingTime, totalRoundTime, currentRound, lastRound]);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      if (remainingTime.roundRemainingTime > 0 && remainingTime.totalRemainingTime > 0) {
        updateRemainingTime(
          remainingTime.totalRemainingTime - 1,
          remainingTime.roundRemainingTime - 1,
        );
      } else {
        clearInterval(timerInterval);
      }
    }, 950);

    return () => {
      clearInterval(timerInterval);
    };
  }, [remainingTime, updateRemainingTime]);
};
